<template>
    <div>
        <h3 class="order__subtitle cart__subtitle">Способ доставки</h3>

        <template v-for="(delivery, index) in deliveryList">
            <div v-if="delivery.id === 'pickup'"
                 :id="delivery.id"
                 class="cart__wrap order__item order__item--delivery js-delivery"
                 :class="{
                     'order__item--active': delivery.active,
                     'order__item--drop': delivery.active || delivery.drop,
                 }"
                 v-bind:key="delivery.id">

                <div class="cart__row"
                     :class="{'disable-div': delivery.active || delivery.drop,}"
                     @click="setDelivery(delivery.id);">
                    <div
                        class="order__label cart__grow"
                        :data-element="$root.getDataElement('cart_delivery_' + delivery.id)"
                    >
                        <div class="cart__name">{{ delivery.name }}</div>
                        {{ delivery.description }}
                    </div>
                </div>


                <div class="order__drop">
                    <hr class="cart__sep">

                    <div class="cart__row">
                        <div class="sel order__sel">
                            <div v-if="selectedCity.NAME"
                                 id="citySelection"
                                 :data-element="$root.getDataElement('cart_delivery_city_select')"
                                 class="sel__trigger"
                                 @click="citySelection()">{{ selectedCity.NAME }}
                            </div>
                            <div v-else
                                 id="citySelection"
                                 :data-element="$root.getDataElement('cart_delivery_city_select')"
                                 class="sel__trigger"
                                 @click="citySelection()">Выберите город
                            </div>

                            <div id="citySelections" class="sel__list">
                                <div v-for="(city, cityKey) in cityList"
                                     :data-value="city.ID"
                                     class="sel__opt"
                                     :key="'city_' + cityKey"
                                     @click="citySelect(delivery.id, cityKey);">
                                    {{ city.NAME }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cart__row">
                        <div class="cart__name">Пункт самовывоза</div>
                    </div>

                    <div class="cart__row">
                        <div v-html="selectedCity.ADDRESS_HTML"></div>
                    </div>

                    <div v-if="mapLink !== false" class="cart__row">
                        <a id="cityMapLink"
                           :href="mapLink"
                           :data-element="$root.getDataElement('cart_delivery_map_link')"
                           target="_blank">Посмотреть на карте</a>
                    </div>
                </div>
            </div>

            <div v-if="delivery.id === 'delivery_and_setup' || delivery.id ===  'delivery_only'"
                 :id="delivery.id"
                 class="cart__wrap order__item js-delivery"
                 :class="{
                     'order__item--active': delivery.active,
                     'order__item--drop': delivery.active || delivery.drop,
                 }"
                 v-bind:key="delivery.id">

                <div class="cart__row"
                     :class="{'disable-div': delivery.active || delivery.drop,}"
                     @click="setDeliveryType(delivery.id);">
                    <div
                        class="order__label cart__grow"
                        :data-element="$root.getDataElement('cart_delivery_' + delivery.id)"
                    >
                        <div class="flx">
                            <div class="cart__grow">
                                <div
                                    class="cart__name"
                                    :data-element="$root.getDataElement('cart_delivery_input_label_' + delivery.id)">
                                    {{ delivery.name }}
                                    <span v-if="delivery.recommended" class="order__rec">Рекомендуем</span>
                                </div>
                            </div>
                            <div class="cart__right">
                                <div class="flx v-centered">
                                            <span class="order__info">
                                                <span class="order__tooltip">
                                                    {{ delivery.descriptionPrice }}
                                                </span>
                                            </span>
                                    <div class="cart__price">
                                        <span class="cart__units">от</span>
                                        <span
                                            class="cart__val cart__val--big"
                                            :data-element="$root.getDataElement('cart_delivery_price_' + delivery.id)"
                                        > {{ delivery.cost }} </span>
                                        <span class="cart__units">руб.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>{{ delivery.description }}</div>
                    </div>
                </div>
                <div class="order__drop">
                    <hr class="cart__sep">

                    <div class="cart__row cart__row--sm">
                        <div class="input order__input">
                            <label :for="'address-search-input-' + delivery.id"
                                   :data-element="$root.getDataElement('cart_address_search_input_label_' + index)"
                                   class="input__label input__label--compact">Адрес</label>
                            <input :id="'address-search-input-' + delivery.id"
                                   :name="delivery.id"
                                   :data-element="$root.getDataElement('cart_address_search_input_' + index)"
                                   class="input__field input__field--compact daData-address-search-input"
                                   :class="{'input__field--error': delivery.error, 'input__field--success': delivery.success}"
                                   type="text"
                                   placeholder="Введите адрес в свободной форме"
                                   @click="deliveryType = delivery.id"
                                   @change="changeAddress"
                                   v-model="delivery.address">
                            <Suggest :type="'address'"
                                     :fieldName="delivery.id"
                                     :keyBlock="delivery.id"
                                     dataElementPrefix="cart-"
                                     @getParseFromDaData="getAddressFromDaData">
                            </Suggest>
                        </div>
                    </div>

                    <div class="cart__row" v-if="delivery.error">
                        <div class="order__error">{{ delivery.error }}</div>
                    </div>

                    <div class="cart__row">
                        <button class="cart__row--green" @click="initMapYMap(delivery.id)">Выбрать на карте</button>
                    </div>

                    <div class="cart__row">
                        <div class="input order__office">
                            <label :for="'office-' + delivery.id"
                                   class="input__label input__label--compact">Офис</label>
                            <input :id="'office-' + delivery.id"
                                   class="input__field input__field--compact js-office"
                                   type="text"
                                   @click="deliveryType = delivery.id"
                                   @change="changeAddress"
                                   v-model="delivery.office"
                                   placeholder="Номер офиса">
                        </div>
                    </div>

                    <template v-if="delivery.details.length > 0">
                        <template v-for="(detail, index) in delivery.details">
                            <div class="cart__row cart__row--sm" v-bind:key="detail.ID">
                                <div class="cart__grow" v-html="detail.NAME"></div>
                                <div class="cart__right">
                                    <div class="cart__price">
                                        <span class="cart__val"> {{ detail.PRICE }} </span>
                                        <span class="cart__units">руб./шт.</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="delivery.id === 'delivery_and_setup' && index === 0"
                                 v-bind:key="'service_' + detail.ID"
                                 :data-element="$root.getDataElement('cart_delivery_delivery_and_setup_details_open_modal')"
                                 class="cart__row cart__row--green">
                                <button class="cart__row--green" @click="openModal('service_' + detail.ID)">
                                    Что включено в услугу?
                                </button>
                            </div>
                        </template>
                    </template>
                </div>

            </div>
        </template>
    </div>
</template>

<script>
import YMapComponent from "./YMapComponent";
import ModalComponent from "./ModalComponent";
import Suggest from "./Suggest.vue";

const ERROR_REPORTER = window.ERROR_REPORTER
const MESSAGE_TYPE_ERROR = window.MESSAGE_TYPE_ERROR

export default {
    name: "DeliveryComponent",
    components: {Suggest},
    data() {
        return {
            loader: true,
            config: {
                'yandexMapsLink': 'https://yandex.ru/maps/?text=',
                'cityCookieName': 'regionCode',
                'alertSetupNotSupported': 'Услуга «Доставка и настройка» недоступна по введенному адресу, введите другой адрес, либо воспользуйтесь услугой доставки оборудования без настройки',
                'alertEmptySetupItems': 'Услуга настройки недоступна для выбранных товаров',
                'alertNotDelivery': 'Доставка в данный регион не осуществляется',
                'alertNotAddress': 'Введите адрес',
                'alertNotExistentAddress': 'Введен несуществующий адрес',
                'alertConfirmedAddress': 'Необходимо проверить и подтвердить адрес',
                'requiredFormNotFilled': 'Не все обязательные поля заполнены',
                'alertNotCalculated': 'К сожалению, в настоящий момент сервис расчета стоимости недоступен. Мы не можем рассчитать для вас стоимость доставки оборудования на сайте. Пожалуйста выберите опцию самовывоз из вашего региона и после подтверждения заказа позвоните по номеру 8 800 555 55 22, наш менеджер сделает вам расчет вручную.',
                'mangoDeliveryNotes': 'Доставка собственной курьерской службой',
                'externalDeliveryNotes': 'Доставка сторонним партнером',
                'errorCalculating': 'Доставка сторонним партнером',
            },
            names: {
                'REQ_CLASS': 'req',
                'CALCULATED_CLASS': 'calculated',
                'DELIVERY_TYPE': 'delivery_type',
                'PICKUP_RADIO_NAME': 'pickup',
            },
            ref: {
                'JS_DADATA_ADDRESS_SEARCH': '.daData-address-search-input',
                'JS_FRM_ADDRESS': '.form-delivery_address',
            },
            cityList: [],
            deliveryList: {
                pickup: {
                    id: 'pickup',
                    cost: '0',
                    name: 'Самовывоз',
                    details: [],
                    hidden: false,
                    recommended: false,
                    description: 'Бесплатно',
                    descriptionPrice: 'Цена может быть изменена',
                    notes: '',
                    address: '',
                    coords: '',
                    drop: false,
                    error: false,
                    success: false,
                    active: false,
                },
                delivery_and_setup: {
                    id: 'delivery_and_setup',
                    cost: '2000',
                    name: 'Доставка и настройка',
                    details: [],
                    hidden: false,
                    recommended: true,
                    description: 'Доверьте настройку профессионалам',
                    descriptionPrice: 'Цена может быть изменена',
                    notes: '',
                    address: '',
                    coords: '',
                    office: '',
                    def_cost: '2000',
                    def_notes: 'Цена может быть изменена',
                    drop: false,
                    error: false,
                    success: false,
                    active: false,
                },
                delivery_only: {
                    id: 'delivery_only',
                    cost: '350',
                    name: 'Курьерская доставка',
                    details: [],
                    hidden: false,
                    recommended: false,
                    description: 'Разбираться с настройкой самостоятельно',
                    descriptionPrice: 'Цена может быть изменена',
                    notes: '',
                    address: '',
                    coords: '',
                    office: '',
                    def_cost: '350',
                    def_notes: '',
                    drop: false,
                    error: false,
                    success: false,
                    active: false,
                },
            },
            confirmedAddress: false,
            daDataToken: '5a585e2ee3e58599595d913c1c702ddf232276db',
            deliveryType: 'pickup',
            mapDistance: false,
            addressString: '',
            currentDelivery: {},
            mapAddress: {
                id: '',
                country: '',
                region: '',
                city: '',
                settlement: '',
                street: '',
                building: '',
                flat: '',
                geo_lat: '',
                geo_lon: '',
                office: '',
            },
            deliveryAndSetupDescription: '',
        }
    },
    methods: {
        createLoader(bool) {
            this.loader = bool;
            this.$emit('createLoader', 'delivery', this.loader)
        },
        countPrice(delivery) {
            let prefix = '';

            switch (delivery.id) {
                case 'delivery_and_setup':
                    prefix = 'ds';
                    delivery.ds_service = {}
                    delivery.ds_service_quantity = {}
                    break;
                default:
                    prefix = 'd';
                    delivery.d_service = {}
                    delivery.d_service_quantity = {}
                    break;
            }

            delivery.details.forEach(function (deliveryDetail, index) {
                delivery[prefix + '_service'][index] = deliveryDetail.ID;
                delivery[prefix + '_service_quantity'][deliveryDetail.ID] = deliveryDetail.QUANTITY;
            });
        },
        changeAddress() {
            let vm = this;
            let delivery = this.deliveryList[vm.deliveryType];

            vm.checkDaData(delivery.address, (data) => {
                vm.getAddressFromDaData(vm.deliveryType, data);
            }, () => {
                if (vm.deliveryList.pickup.id !== vm.deliveryType) {
                    vm.clearMapAddress();
                    vm.setDeliveryYMap(vm.deliveryType);
                }
                if (delivery.address === '') {
                    delivery.error = vm.config.alertNotAddress;
                } else {
                    delivery.error = vm.config.alertNotExistentAddress;
                }
            });
        },
        checkDaData(query, successCallback, errorCallback) {
            let vm = this;
            let url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
            let token = vm.daDataToken;

            let options = {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + token
                },
                body: JSON.stringify({query: query, count: 1})
            }

            fetch(url, options)
                .then(response => response.json())
                .then(result => {
                    if (result.suggestions.length > 0) {
                        successCallback(result.suggestions[0].data);
                    } else {
                        errorCallback();
                    }
                }).catch(() => {
                errorCallback();
            });
        },
        getAddressFromDaData(deliveryType, data) {
            let vm = this;
            let delivery = this.deliveryList[deliveryType];

            if (data === undefined) {
                return false;
            }

            this.clearMapAddress();

            this.mapAddress.country = data.country;
            this.mapAddress.region = data.region;
            this.mapAddress.geo_lat = data.geo_lat;
            this.mapAddress.geo_lon = data.geo_lon;

            let city, settlement, street, building, flat;

            if (data.city) {
                city = data['city_type'] + '. ' + data.city;
            }

            if (data.settlement) {
                settlement = data['settlement_type'] + '. ' + data.settlement;
            }

            if (!data.city && data.area) {
                city = data['area_type'] + '. ' + data.area;
            }

            if (data.street) {
                street = data['street_type'] + '. ' + data.street;
            }

            if (data.house) {
                building = data['house_type'] + '. ' + data.house;
            }

            if (data.block) {
                building += ', ' + data['block_type'] + '. ' + data.block
            }
            if (data.flat) {
                flat = data['flat_type'] + '. ' + data.flat;
            }

            if (delivery.office) {
                this.mapAddress.office = delivery.office;
            }

            let place = [];

            if (city && city.length > 0) {
                place.push(city);
                this.mapAddress.city = city
            }

            if (settlement && settlement.length > 0) {
                place.push(settlement);
                this.mapAddress.settlement = settlement
            }

            if (street && street.length > 0) {
                place.push(street);
                this.mapAddress.street = street
            }

            if (building && building.length > 0) {
                place.push(building);
                this.mapAddress.building = building
            }

            if (data['region_with_type'] && data['region_with_type'] !== data['city_with_type'] && data['region_with_type'].length > 0) {
                this.mapAddress.region = data['region_with_type']
            }

            if (this.mapAddress.region && place.length > 0 && this.mapAddress.city !== 'undefined') {
                vm.getDistance(place.join(', '), this.mapAddress, this.mapAddress.region);
            }

            let prefix = (data['region_with_type'] !== data['city_with_type']) ? data['region_with_type'] + ', ' : '';
            vm.addressString = prefix + place.join(', ') + (flat ? ', ' + flat : '');
        },
        getDistance(fullArea, arAddress, area) {
            let vm = this;
            let delivery = this.deliveryList[vm.deliveryType]

            this.$api.request('/api/cart-confirm/getDistance/', 'post', {
                'fullarea': fullArea,
                'formData': JSON.stringify(arAddress),
                'area': area,
            }).then((response) => {
                if (!vm.setDeliveryCost(response.data)) {
                    vm.clearMapAddress();
                }
                vm.setDeliveryYMap(vm.deliveryType);
            }).catch(() => {
                delivery.error = vm.config.errorCalculating;
            });

            return false;
        },
        setDeliveryCost(data) {
            const vm = this;
            let ds_exist = false;

            Object.values(vm.deliveryList).forEach(function (el) {
                let blockType;

                switch (el.id) {
                    case 'delivery_and_setup':
                        blockType = 'delivery_and_setup';
                        ds_exist = true;
                        break;
                    case 'delivery_only':
                        blockType = 'delivery';
                        break;
                }

                if (blockType !== undefined) {
                    if (!data[blockType]) {
                        el.hidden = true;
                        el.address = '';
                        el.details = [];
                        el.cost = el.def_cost;
                        el.notes = el.def_notes;
                    } else {
                        el.hidden = false;
                        el.address = vm.addressString;
                        el.details = [];
                        for (let k in data[blockType].items) {
                            let item = data[blockType].items[k];
                            item.NAME = item.NAME.replace('Настройка: Настройка', 'Настройка');
                            el.details.push(item);
                        }
                        if (blockType === 'delivery') {
                            if (el.name !== data[blockType].title) {
                                el.notes = vm.config.externalDeliveryNotes;
                            } else {
                                el.notes = vm.config.mangoDeliveryNotes;
                            }
                        } else {
                            el.name = data[blockType].title;
                        }
                    }
                }
            });

            this.deliveryList[vm.deliveryType]['error'] = false;
            this.deliveryList[vm.deliveryType]['success'] = true;

            if (
                ds_exist
                && !data['delivery_and_setup']
                && vm.deliveryType === 'delivery_and_setup'
            ) {
                this.deliveryList[vm.deliveryType]['success'] = false;
                if (data['has_setup_items'] === 0) {
                    this.deliveryList[vm.deliveryType]['error'] = vm.config.alertEmptySetupItems;
                } else {
                    this.deliveryList[vm.deliveryType]['error'] = vm.config.alertSetupNotSupported;
                }
            }
            if (!data['delivery_and_setup'] && !data['delivery']) {
                this.deliveryList[vm.deliveryType]['success'] = false;
                this.deliveryList[vm.deliveryType]['error'] = vm.config.alertNotDelivery;
                vm.deliveryType = 'pickup';
            }

            return this.deliveryList[vm.deliveryType]['success'] === true;
        },
        initMapYMap(deliveryId) {
            let self = this;
            let coords = this.selectedCity.MAP

            if (self.deliveryList[deliveryId]['coords']) {
                coords = [
                    self.deliveryList[deliveryId]['coords']['lat'],
                    self.deliveryList[deliveryId]['coords']['lon']
                ];
            }

            if (self.mapAddress.geo_lat && self.mapAddress.geo_lon) {
                coords = [self.mapAddress.geo_lat, self.mapAddress.geo_lon]
            }

            self.$modal.show(YMapComponent, {
                deliveryId: deliveryId,
                coords: coords,
                confirmedAddress: function (deliveryId, fullAddress, office) {
                    self.deliveryList[deliveryId]['office'] = office;
                    self.deliveryList[deliveryId]['address'] = fullAddress;
                    self.changeAddress();
                }
            });
        },
        citySelection() {
            let citySelection = document.getElementById('citySelection');
            let citySelections = document.getElementById('citySelections');

            citySelection.classList.toggle('sel__trigger--open');
            citySelections.classList.toggle('sel__list--open');
        },
        citySelect(deliveryId, cityKey) {
            this.cityList.some(function (city) {
                if (city['SELECTED']) {
                    city['SELECTED'] = false;
                }
            });

            this.cityList[cityKey]['SELECTED'] = true;

            this.citySelection();
            this.setDelivery(deliveryId);
        },
        setDelivery(deliveryId) {
            this.activeDelivery(deliveryId);
            this.dropDelivery(deliveryId);

            if (this.selectedCity.ID) {
                this.createLoader(true);
                this.currentDelivery.filial = this.selectedCity.ID;

                this.$api.request('/api/cart-confirm/setDelivery/', 'post', {
                    'delivery_type': deliveryId,
                    'pickup_from': this.selectedCity.ID,
                }).then(() => {
                    this.$emit('reloadCart');
                    this.createLoader(false);
                }).catch(() => {
                    this.createLoader(false);
                    ERROR_REPORTER.showMessage(this.config.alertNotCalculated, MESSAGE_TYPE_ERROR);
                });
            }
        },
        setDeliveryType(deliveryId) {
            this.deliveryType = deliveryId
            this.createLoader(true);
            this.activeDelivery(deliveryId);
            this.dropDelivery(deliveryId);
            this.changeAddress();
        },
        setDeliveryYMap(deliveryId) {
            let delivery = this.deliveryList[deliveryId];
            this.countPrice(delivery);

            let dataForm = {
                delivery_type: deliveryId,
                region: this.mapAddress.region,
                city: this.mapAddress.city,
                settlement: this.mapAddress.settlement,
                street: this.mapAddress.street,
                building: this.mapAddress.building,
                coords: JSON.stringify({
                    lat: this.mapAddress.geo_lat,
                    lon: this.mapAddress.geo_lon
                }),
                office: delivery.office,
                ds_service: JSON.stringify(delivery.ds_service),
                ds_service_quantity: JSON.stringify(delivery.ds_service_quantity),
                d_service: JSON.stringify(delivery.d_service),
                d_service_quantity: JSON.stringify(delivery.d_service_quantity),
            }
            this.$api.request('/api/cart-confirm/setDelivery/', 'post', dataForm).then(() => {
                this.$emit('reloadCart');
                this.createLoader(false);
            }).catch(() => {
                this.createLoader(false);
                ERROR_REPORTER.showMessage(this.config.alertNotCalculated, MESSAGE_TYPE_ERROR);
            });
        },
        getCookie(name) {
            let matches = document.cookie.match(new RegExp(
                "(?:^|; )" + name.replace('([.$?*|{}()[]/+^])', '\\$1') + "=([^;]*)"));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        },
        openModal(id) {
            this.$modal.show(ModalComponent, {
                id: id,
                body: this.deliveryAndSetupDescription,
            }, {},
            {
                'opened': this.onModalOpened,
            });
        },
        onModalOpened() {
            let deliveryBtn = document.querySelector('.delivery__btn');
            let deliveryInfo = document.querySelector('.delivery__info');

            if (!deliveryBtn || !deliveryInfo) {
                return;
            }

            deliveryBtn.addEventListener('click', function () {
                deliveryInfo.classList.toggle('delivery__info--active');
            });
        },
        activeDelivery(deliveryId) {
            Object.values(this.deliveryList).forEach(function (delivery) {
                delivery.active = delivery.id === deliveryId;
            });
        },
        dropDelivery(deliveryId) {
            Object.values(this.deliveryList).forEach(function (delivery) {
                delivery.drop = delivery.id === deliveryId;
            });
        },
        clearMapAddress() {
            for (let key in this.mapAddress) {
                this.mapAddress[key] = '';
            }
        },
    },
    computed: {
        selectedCity: function () {
            let result = {};

            this.cityList.some(function (el) {
                if (el.SELECTED) {
                    result = el;
                }
            });

            return result;
        },
        mapLink: function () {
            let vm = this;
            if (vm.selectedCity.ID !== undefined) {
                let s = 'Россия, ' + vm.selectedCity.NAME + ', ' + vm.selectedCity.DELIVERY_ADDRESS;
                return vm.config.yandexMapsLink + s;
            }
            return false;
        },
    },
    mounted() {
        this.$api.request('/api/cart-confirm/getDelivery/', 'get').then((response) => {
            let cityFromCookie = this.getCookie(this.config.cityCookieName) ? this.getCookie(this.config.cityCookieName) : 'moskva';
            let responseCityList = response.data['delivery']['BRANCHES_FOR_PICKUP'];

            this.deliveryAndSetupDescription = response.data['deliveryAndSetupDescription'];
            if (Object.keys(response.data['currentDelivery']).length !== 0) {
                this.currentDelivery.filial = response.data['currentDelivery']['filial'];

                this.deliveryType = response.data['currentDelivery']['code'];
                this.deliveryList[response.data['currentDelivery']['code']]['address'] = response.data['currentDelivery']['address'];
                this.deliveryList[response.data['currentDelivery']['code']]['office'] = response.data['currentDelivery']['office'];
                this.deliveryList[response.data['currentDelivery']['code']]['coords'] = JSON.parse(response.data['currentDelivery']['coords']);
                this.deliveryList[response.data['currentDelivery']['code']]['active'] = true;

                if (
                    response.data['currentDelivery']['code'] === 'delivery_and_setup'
                    || response.data['currentDelivery']['code'] === 'delivery_only'
                ) {
                    this.changeAddress();
                } else {
                    this.createLoader(false);
                }
            }

            Object.keys(responseCityList).forEach(city => {
                let selected = false;
                if (cityFromCookie === responseCityList[city].CODE) {
                    selected = true;
                }

                if (responseCityList[city].ID === this.currentDelivery.filial) {
                    selected = true;
                }

                this.cityList.push({
                    'ID': responseCityList[city]['ID'],
                    'NAME': responseCityList[city]['NAME'],
                    'ADDRESS_HTML': responseCityList[city]['ADDRESS'],
                    'DELIVERY_ADDRESS': responseCityList[city]['DELIVERY'],
                    'CODE': responseCityList[city]['CODE'],
                    'MAP': responseCityList[city]['MAP'].split(','),
                    'SELECTED': selected,
                });
            })

            this.createLoader(false);
        }).catch(() => {
            this.createLoader(false);
            ERROR_REPORTER.showMessage(this.config.alertNotCalculated, MESSAGE_TYPE_ERROR);
        });
    },
}
</script>